"use client";
import { useRouter } from "next/navigation";
import React from "react";

export default function SectionOne(props) {
  const data = props.data;
  const router = useRouter();
  return (
    <div className="card-section highlights">
      <div className="card" onClick={() => router.push(`/why-factorycat`)}>
        <h2>Why FactoryCat?</h2>
      </div>
      <div className="card" onClick={() => router.push(`/videos`)}>
        <h2>Videos</h2>
      </div>
      <div
        className="card"
        onClick={() => router.push(`/models/gallery/${data.slug}`)}
      >
        <h2>Images</h2>
      </div>
      <div className="card" onClick={() => router.push(`/applications`)}>
        <h2>Applications</h2>
      </div>
    </div>
  );
}
